/*
 * EXPORTS
 */
export const rowStyle = {
  'fontWeight': '500',
  'fontSize': 'Clamp(13px, 1.5vw, 15px)',
  'textAlign': 'center',
  'minWidth': '210px',
  'maxWidth': '210px',
  'overflowX': 'auto'
}
export const headerStyle = {
  'fontFamily': 'DM Sans',
  'fontWeight': '600',
  'fontSize': '17px',
  'height': '50px',
  'color': '#8D97B5',
  'backgroundColor': '#F4F7FD',
  'textAlign': 'center'
}
export const cellStyle = {
  'fontFamily': 'Dm Sans',
  'color': 'rgba(43, 54, 116, 1)',
  'fontWeight': '700',
  'fontSize': '18px',
  'lineHeight': '24px',
  'letterSpacing': '-0.36px'
}
export const buttonStyle = {
  'backgroundColor': 'rgba(244, 247, 254, 1)',
  'color': 'rgba(92, 55, 255, 1)',
  'fontFamily': 'Dm Sans',
  'fontWeight': '500',
  'fontSize': '16px',
  'lineHeight': '32px',
  'letterSpacing': '-0.22px',
  'borderRadius': '10px'
}
export const lastRowStyle = {
  'position': 'absolute',
  'width': '100%',
  'bottom': 0,
  'left': 0,
  'display': 'inline-table'
}
